export enum GenderType {
  Male = "M",
  Female = "F",
  Unspecified = "N",
}
